module.exports = __webpack_public_path__ + "fonts/NeutraTextTF-Book.9f5cbd54960a1e8784efe6235ab6762a.otf";